import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Pager from "components/ui/controls/pager/pager";
import ContributionSpecifiquePageModal from "pages/audit complet/situation professionnelle/modules/contribution specifique modal";
import Button from "components/ui/controls/button/button";
import { FaTrashAlt, FaBuilding, FaCoins } from "react-icons/fa";
import { applyFormat } from "components/ui/ui-helpers";
import { createStyledButton } from "components/ui/controls/button/button-styles";

function ParamFicheDePaie(props) {
  const context = useContext(AppContext);

  return (
    <>
      <>
        <Pager
          pages={[
            {
              content: (
                <div className="prise-en-charge-container">
                  <Column pad fill>
                    <CardBox>
                      <Column fill>
                        <div className="dossier-header">
                          <div className="dossier-header-icon">
                            <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                          </div>
                          <span className="dossier-header-title">Cotisations URSSAF</span>
                        </div>
                        <Row>
                          <Column>
                            <TextField
                              value={context.state[props.Outil + "TauxActivite" + props.ClientConjoint]}
                              onChange={context.handleInputChange(props.Outil + "TauxActivite" + props.ClientConjoint)}
                              label="Taux d'activité"
                              dataType="ufloat"
                              format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                              normal
                            />
                          </Column>
                          <Column hpad>
                            <TextField
                              value={context.state[props.Outil + "AccidentTravail" + props.ClientConjoint]}
                              onChange={context.handleInputChange(props.Outil + "AccidentTravail" + props.ClientConjoint)}
                              label="Accident du travail"
                              dataType="ufloat"
                              format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                              normal
                            />
                          </Column>
                          <Column>
                            <TextField
                              value={context.state[props.Outil + "Transport" + props.ClientConjoint]}
                              onChange={context.handleInputChange(props.Outil + "Transport" + props.ClientConjoint)}
                              label="Versement transport"
                              dataType="ufloat"
                              format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                              normal
                            />
                          </Column>
                        </Row>
                        <Row tpad>
                          <Column>
                            <DropDown
                              label="Contribution à la formation"
                              value={context.state[props.Outil + "Formation" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "Formation" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          <Column hpad>
                            <DropDown
                              label="Taxe d'apprentissage"
                              value={context.state[props.Outil + "Apprentissage" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "Apprentissage" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          <Column>
                            <DropDown
                              label="Effectif salarié"
                              value={context.state[props.Outil + "Effectif" + props.ClientConjoint]}
                              options={[
                                { value: "-11", label: "Moins de 11" },
                                { value: "11-19", label: "Entre 11 et 49" },
                                { value: "+20", label: "A compter de 50" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "Effectif" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                        </Row>
                        <Row>
                          <Column>
                            <DropDown
                              label="Assurance chômage"
                              value={context.state[props.Outil + "AssuranceChomage" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "AssuranceChomage" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          <Column hpad>
                            <DropDown
                              label="Réduction générale"
                              value={context.state[props.Outil + "ReductionGenerale" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "ReductionGenerale" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          <Column>
                            <DropDown
                              label="Taxe sur les salaires"
                              value={context.state[props.Outil + "TaxeSalaire" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "TaxeSalaire" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                        </Row>
                        <Row>
                          <Column>
                            <DropDown
                              label="Régime Alsace-Moselle"
                              value={context.state[props.Outil + "Regime" + props.ClientConjoint]}
                              options={[
                                { value: "non", label: "Non" },
                                { value: "oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "Regime" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          <Column hpad>
                            <TextField
                              label="Avantages en nature"
                              value={context.state[props.Outil + "AvantageNature" + props.ClientConjoint]}
                              onChange={context.handleInputChange(props.Outil + "AvantageNature" + props.ClientConjoint)}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                              normal
                            />
                          </Column>
                          <Column>
                            <DropDown
                              label="Affiliation CAVEC"
                              value={context.state[props.Outil + "CavecSalarie" + props.ClientConjoint]}
                              options={[
                                { value: "Non", label: "Non" },
                                { value: "C", label: "Classe C" },
                                { value: "D", label: "Classe D" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "CavecSalarie" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                        </Row>
                        <Row>
                          <Column>
                            <DropDown
                              label="Affiliation CNBF"
                              value={context.state[props.Outil + "CnbfSalarie" + props.ClientConjoint]}
                              options={[
                                { value: "Non", label: "Non" },
                                { value: "Oui", label: "Oui" },
                              ]}
                              onChange={context.handleInputChange(props.Outil + "CnbfSalarie" + props.ClientConjoint)}
                              normal
                            />
                          </Column>
                          {context.state[props.Outil + "CnbfSalarie" + props.ClientConjoint] === "Oui" && (
                            <>
                              <Column hpad>
                                <DropDown
                                  label="Ancienneté"
                                  value={context.state[props.Outil + "AncienneteCnbf" + props.ClientConjoint]}
                                  onChange={context.handleInputChange(props.Outil + "AncienneteCnbf" + props.ClientConjoint)}
                                  options={[
                                    {
                                      value: "1",
                                      label: "1",
                                    },
                                    {
                                      value: "2",
                                      label: "2",
                                    },
                                    {
                                      value: "3",
                                      label: "3",
                                    },
                                    {
                                      value: "4",
                                      label: "4",
                                    },
                                    {
                                      value: "5",
                                      label: "5",
                                    },
                                    {
                                      value: "6",
                                      label: "6 et +",
                                    },
                                  ]}
                                  normal
                                />
                              </Column>
                              <Column>
                                <DropDown
                                  label="Classe retraite"
                                  value={context.state[props.Outil + "ClasseRetraiteCnbf" + props.ClientConjoint]}
                                  onChange={context.handleInputChange(props.Outil + "ClasseRetraiteCnbf" + props.ClientConjoint)}
                                  options={[
                                    {
                                      value: "C1",
                                      label: "C1",
                                    },
                                    {
                                      value: "C2",
                                      label: "C2",
                                    },

                                    {
                                      value: "C2+",
                                      label: "C2+",
                                    },
                                  ]}
                                  normal
                                />
                              </Column>
                            </>
                          )}
                        </Row>
                        <Row>
                          <div className="dossier-header">
                            <div className="dossier-header-icon">
                              <FaBuilding style={{ color: "#6b7280", fontSize: "16px" }} />
                            </div>
                            <span className="dossier-header-title">Cotisations retraite AGIRC ARRCO</span>
                          </div>
                        </Row>
                        <Row>
                          <Column>
                            <div className="prise-en-charge-table-container">
                              <table className="mono">
                                <tbody>
                                  <tr>
                                    <td></td>
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                      <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                        Salarié
                                      </label>
                                    </td>
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                      <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                        Patronale
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ verticalAlign: "middle", marginBottom: 0 }}>
                                      <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                        Tranche 1
                                      </label>
                                    </td>
                                    <td>
                                      <TextField
                                        value={context.state[props.Outil + "AgircArrcoT1Sal" + props.ClientConjoint]}
                                        onChange={context.handleInputChange(props.Outil + "AgircArrcoT1Sal" + props.ClientConjoint)}
                                        dataType="ufloat"
                                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                        normal
                                        style={{ textAlign: "center" }}
                                      />
                                    </td>
                                    <td>
                                      <TextField
                                        value={context.state[props.Outil + "AgircArrcoT1Pat" + props.ClientConjoint]}
                                        onChange={context.handleInputChange(props.Outil + "AgircArrcoT1Pat" + props.ClientConjoint)}
                                        dataType="ufloat"
                                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                        normal
                                        style={{ textAlign: "center" }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ verticalAlign: "middle" }}>
                                      <label style={{ marginBottom: 0 }} className="prise-en-charge-cell-label">
                                        Tranche 2
                                      </label>
                                    </td>
                                    <td>
                                      <TextField
                                        value={context.state[props.Outil + "AgircArrcoT2Sal" + props.ClientConjoint]}
                                        onChange={context.handleInputChange(props.Outil + "AgircArrcoT2Sal" + props.ClientConjoint)}
                                        dataType="ufloat"
                                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                        normal
                                        style={{ textAlign: "center" }}
                                      />
                                    </td>
                                    <td>
                                      <TextField
                                        value={context.state[props.Outil + "AgircArrcoT2Pat" + props.ClientConjoint]}
                                        onChange={context.handleInputChange(props.Outil + "AgircArrcoT2Pat" + props.ClientConjoint)}
                                        dataType="ufloat"
                                        format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                                        normal
                                        style={{ textAlign: "center" }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Column>
                        </Row>
                        <Row>
                          <div className="dossier-header">
                            <div className="dossier-header-icon">
                              <FaCoins style={{ color: "#6b7280", fontSize: "16px" }} />
                            </div>
                            <span className="dossier-header-title">Contributions spécifiques </span>
                          </div>
                        </Row>
                        <Row >
                          <ContributionSpecifiquePageModal Outil={props.Outil} ClientConjoint={props.ClientConjoint} />
                        </Row>
                        <Row >
                          <Column fill>
                            {context.state[props.Outil + "TabCotisationsManuelle" + props.ClientConjoint]?.length === 0 ? (
                              <div
                                style={{
                                  backgroundColor: "#f9fafb",
                                  border: "1px dashed #d1d5db",
                                  borderRadius: "8px",
                                  padding: "16px",
                                  textAlign: "center",
                                  color: "#6b7280",
                                  width: "100%",
                                }}
                              >
                                Aucune contribution spécifique n'a été ajoutée
                              </div>
                            ) : (
                              context.state[props.Outil + "TabCotisationsManuelle" + props.ClientConjoint]?.map((Infos, Index) => (
                                <div className="contrat-card" key={"contSpe" + Index}>
                                  <div className="contrat-card-content">
                                    <div className="contrat-card-icon">
                                      <FaCoins style={{fontSize:"14px"}} />
                                    </div>

                                    <div className="contrat-card-info">
                                      <h4 className="contrat-card-title">{Infos.Libelle}</h4>
                                      <div className="contrat-card-meta">
                                        <span className="contrat-card-badge">Assiette : {Infos.TypeCotisation === "proportionnelle" ? Infos.Assiette : "Forfaitaire" || "Cotisation"}</span>
                                      </div>
                                      <div className="contrat-card-meta">
                                        <span className="contrat-card-badge">
                                          {Infos.TypeCotisation === "proportionnelle" ? "Taux salarié" : "Salarié"} :
                                          {applyFormat(
                                            Infos.TauxSalariale,
                                            Infos.TypeCotisation === "proportionnelle" ? "ufloat" : "uint",
                                            Infos.TypeCotisation === "proportionnelle"
                                              ? { thousands: " ", decimal: ",", precision: 3, unit: "%" }
                                              : { thousands: " ", decimal: ",", unit: " €" }
                                          )}
                                          /{Infos.TypeCotisation === "proportionnelle" ? "Taux employeur" : "Employeur"} :
                                          {applyFormat(
                                            Infos.TauxPatronale,
                                            Infos.TypeCotisation === "proportionnelle" ? "ufloat" : "uint",
                                            Infos.TypeCotisation === "proportionnelle"
                                              ? { thousands: " ", decimal: ",", precision: 3, unit: "%" }
                                              : { thousands: " ", decimal: ",", unit: " €" }
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <Button
                                    onClick={() => {
                                      context.handleDeleteCotisationManuelle(Infos.id, "", props.ClientConjoint);
                                    }}
                                    icon
                                    {...createStyledButton("card-action", "delete")}
                                  >
                                    <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                                  </Button>
                                </div>
                              ))
                            )}
                          </Column>
                        </Row>
                      </Column>
                    </CardBox>
                  </Column>
                </div>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: () => {
                props.onClose();
              },
            },
          }}
        />
      </>
    </>
  );
}

export default ParamFicheDePaie;
// <div
//                               key={"contSpe" + Index}
//                               style={{
//                                 backgroundColor: "white",
//                                 border: "1px solid #e5e7eb",
//                                 borderRadius: "12px",
//                                 padding: "16px",
//                                 width: "100%",
//                                 marginBottom: "12px",
//                                 boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                               }}
//                             >
//                               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                                 <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
//                                   <div
//                                     style={{                                          width: "48px",
//                                       height: "48px",
//                                       borderRadius: "50%",
//                                       backgroundColor: "#f0fdf4",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       marginRight: "16px",
//                                     }}
//                                   >
//                                     <FaCoins style={{ fontSize: "16px", color: "#10b981" }} />
//                                   </div>
//                                   <div style={{ flex: 1 }}>
//                                     <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
//                                       <h4
//                                         style={{
//                                           margin: 0,
//                                           fontSize: "16px",
//                                           fontWeight: "600",
//                                           color: "#1f2937",
//                                         }}
//                                       >
//                                         {Infos.Libelle}
//                                       </h4>
//                                     </div>                                        <div style={{ display: "flex", gap: "12px", flexDirection: "column", alignItems: "flex-start" }}>
//                                       <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                         <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>Assiette :</span>
//                                         <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>{Infos.Assiette}</span>
//                                       </div>
//                                       <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                         <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
//                                           Salarié : {applyFormat(
//                                             Infos.TauxSalariale,
//                                             Infos.TypeCotisation === "proportionnelle" ? "ufloat" : "uint",
//                                             Infos.TypeCotisation === "proportionnelle"
//                                               ? { thousands: " ", decimal: ",", precision: 3, unit: "%" }
//                                               : { thousands: " ", decimal: ",", unit: " €" }
//                                           )}
//                                         </span>
//                                         <span style={{ fontSize: "12px", color: "#6b7280" }}>/</span>
//                                         <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500" }}>
//                                           Employeur : {applyFormat(
//                                             Infos.TauxPatronale,
//                                             Infos.TypeCotisation === "proportionnelle" ? "ufloat" : "uint",
//                                             Infos.TypeCotisation === "proportionnelle"
//                                               ? { thousands: " ", decimal: ",", precision: 3, unit: "%" }
//                                               : { thousands: " ", decimal: ",", unit: " €" }
//                                           )}
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                                 <Button
//                                   onClick={() => {
//                                     context.handleDeleteCotisationManuelle(Infos.id, "", props.ClientConjoint);
//                                   }}
//                                   icon
//                                   {...createStyledButton("card-action", "delete")}
//                                 >
//                                   <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
//                                 </Button>
//                               </div>
//                             </div>
